import Litepicker from "litepicker"
import Component from "../core/Component"
import { triggerEvent } from "../utils/dom"
import "litepicker/dist/plugins/mobilefriendly"

export const EMITS = {
    SELECTED: "selected",
    FOCUS: "focus",
    BLUR: "blur",
}
export default class FormDaterange extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            originalFrom: null,
            originalTo: null,
            from: null,
            to: null,
        }

        this._isFocus = false
    }

    prepare() {
        const startDate = new Date(this.ref.originalFrom.value)
		if (startDate) {
			this.ref.from.value = this.ref.originalFrom.value
		}
        const endDate = new Date(this.ref.originalTo.value)
		if (endDate) {
			this.ref.to.value = this.ref.originalTo.value
		}

        this.picker = new Litepicker({
            element: this.ref.from,
            elementEnd: this.ref.to,
            singleMode: false,
            startDate,
            endDate,
            autoRefresh: true,
			format: 'D.M.YYYY',
            tooltipText: {
                one: "den",
                few: "dny",
                other: "dní",
            },
            lang: 'cs-CZ',
            plugins: ["mobilefriendly"],
        })

        this.picker.on("selected", (date1, date2) => {
            this.ref.originalFrom.value = `${date1.getFullYear()}-${date1.getMonth()+1}-${date1.getDate()}`
			this.ref.originalTo.value = `${date2.getFullYear()}-${date2.getMonth()+1}-${date2.getDate()}`
            this.emit(EMITS.SELECTED, {
                date1,
                date2,
            })
            triggerEvent(this.ref.originalFrom, "change")
        })

        this.picker.on('show', () => {
            this._isFocus = true
            triggerEvent(this.element, 'focus')
        })

        this.picker.on('hide', () => {
            this._isFocus = false
            triggerEvent(this.element, 'blur')
        })

        this.ref.from.addEventListener('focus', this.handleInputFocus)
        this.ref.from.addEventListener('blur', this.handleInputBlur)
        this.ref.to.addEventListener('focus', this.handleInputFocus)
        this.ref.to.addEventListener('blur', this.handleInputBlur)
    }

    handleInputFocus = () => {
        this._isFocus = true
        triggerEvent(this.element, 'focus')
    }

    handleInputBlur = () => {
        this._isFocus = false
        triggerEvent(this.element, 'blur')
    }

    getDates() {
        return {
            dateFrom: this.picker?.getStartDate()?.dateInstance,
            dateTo: this.picker?.getEndDate()?.dateInstance
        }
    }

    setDates({ dateFrom, dateTo }) {
		if (dateFrom || dateTo) {
            if (dateFrom) {
                this.picker.setStartDate(dateFrom)
            }
            if (dateTo) {
                this.picker.setEndDate(dateTo)
            }
        } else {
			this.picker.clearSelection()
			triggerEvent(this.ref.originalInput, 'change')
		}
	}

    destroy() {
        this.picker?.destroy()
    }

    show() {
        this.picker.show()
    }

    isEmpty() {
        return !this.ref.originalFrom.value && !this.ref.originalTo.value
    }

    isFocus() {
        return this._isFocus
    }
}

function parseDateFromString(value) {
    const {day,month,year} = value.split('.')
    if (day && month && year) {
        const date = new Date
        date.setDate(day)
        date.setMonth(month - 1)
        date.setFullYear(year)
        return date
    }
    return null
}

function convertDateToString(date) {
    return date ? `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}` : ``
}